<div class="outer-container">
    <div *ngIf="notEnoughData;else widaDetails" class="col-12 not-enough-data-txt h6">
        Not enough speaking data from this school year to generate {{getScoringSystemName()}} predictions.<br><br>Keep using Joy School
        English to get enough speaking opportunities to generate data.
    </div>
    <ng-template class="row" #widaDetails>
        <div class="wida-inner-container-score">
            <div class="wida-long-line">Equivalent {{widaPredictionDetails.PredictionsType}}&nbsp;Score</div>
            <div class="wida-number-container">
                <div class="wida-number-box">
                    <div class="wida-number">
                        {{ widaPredictionDetails.CurrentPredictedScore }}</div>
                </div>
            </div>
        </div>
        <div class="wida-inner-container-chart">
            <div class="wida-growth-chart-box">
                <!-- the chart needs to be the only child of its
                    immediate container to resize itself correctly -->
                <div class="chart-parent pl-0"> 
                    <canvas #widaGrowthChart>{{ chart }}</canvas>
                </div>
                <div id="legend-container" class="chart-legend"></div>
            </div>
        </div>
    </ng-template>
</div>